import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import apiService from '../services/api';

/**
 * 活动接龙导入页面
 * 粘贴接龙内容后，自动批量将名单导入报名列表
 */
const ActivityImportSolitaire = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [content, setContent] = useState('');
  const [importing, setImporting] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  // 解析接龙内容，返回名单数组
  function parseSolitaire(text) {
    // 匹配以数字加点或数字加中文句号开头的行
    const lines = text.split(/\r?\n/);
    const members = [];
    let foundList = false;
    for (let line of lines) {
      const match = line.match(/^\s*(\d+)[.．]\s*(.+)$/);
      if (match) {
        foundList = true;
        members.push(match[2].trim());
      } else if (foundList && !line.trim()) {
        // 已经进入名单区，遇到空行可提前终止
        break;
      }
    }
    return members;
  }

  // 导入名单，批量报名
  async function handleImport() {
    setImporting(true);
    setError('');
    setResult(null);
    try {
      const names = parseSolitaire(content);
      if (names.length === 0) throw new Error('未识别到有效的接龙名单');
      // 调用后端API批量报名
      const resp = await apiService.importSolitaire(id, names);
      setResult(resp.data);
    } catch (e) {
      setError(e.message || '导入失败');
    } finally {
      setImporting(false);
    }
  }

  return (
    <div className="container mt-4">
      <h2>导入接龙名单</h2>
      <p className="text-muted">请粘贴完整的接龙内容，系统将自动识别1.、2.、3.等编号后的人名并批量报名。</p>
      <textarea
        className="form-control mb-3"
        rows={10}
        value={content}
        onChange={e => setContent(e.target.value)}
        placeholder={
          '#接龙\n本周六打球（5/10）\n下午1点-4点\n新跃岛每人20元\n\n1. 王小惠\n2. 康小璐\n3. 李小慧\n...'
        }
      />
      <div className="d-flex justify-content-end gap-2 mt-2">
        <button className="btn btn-primary" onClick={handleImport} disabled={importing || !content.trim()}>
          {importing ? '导入中...' : '批量导入'}
        </button>
        <button className="btn btn-secondary" onClick={() => navigate(-1)}>返回活动</button>
      </div>
      {error && <div className="alert alert-danger mt-3">{error}</div>}
      {result && (
        <div className="alert alert-success mt-3">
          导入完成：<br/>
          <span className="me-3">成功报名 {result.success_count} 人</span>
          <span className="me-3">已报名 {result.already_count || 0} 人</span>
          <span className="me-3">未匹配到用户 {result.failed_names?.length || 0} 人</span>
          {result.failed_names?.length > 0 && (
            <div className="mt-2">
              未匹配到的昵称：{result.failed_names.join('，')}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ActivityImportSolitaire;
